module.exports = __webpack_public_path__ + "static/img/pro_02.66cd029.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent/pro_02.png
// module id = AMU+
// module chunks = 6